export const Others: LoginWay[] = [
	{ id: "0", name: "01 其他发票" },
	{ id: "1", name: "02 停车费发票" },
	{ id: "2", name: "03 市内交通发票" },
	{ id: "3", name: "04 出租车发票" },
	{ id: "4", name: "05 长途车票" },
	{ id: "5", name: "06 高铁、火车车票" },
	{ id: "6", name: "07 航空服务发票" },
	{ id: "7", name: "08 高速公路发票" },
	{ name: "09 办公用品类发票", id: "8" },
	{ name: "10 食品类发票（除烟、酒外）", id: "9" },
	{ name: "11 日用品类发票", id: "10" },
	{ name: "12 餐饮服务类发票", id: "11" },
	{ name: "13 燃料、动力类发票", id: "12" },
	{ name: "14 住宿服务类发票", id: "13" },
	{ name: "15 水电服务类发票", id: "14" }
];
export const Providers: DataTable.DropItem[] = [
	{ text: "办公用品类发票", id: "0" },
	{ text: "食品类发票（除烟、酒外）", id: "1" },
	{ text: "日用品类发票", id: "2" },
	{ text: "餐饮服务类发票", id: "3" },
	{ text: "燃料、动力类发票", id: "4" },
	{ text: "住宿服务类发票", id: "5" },
	{ text: "水电服务类发票", id: "6" },
	{ id: "9", text: "停车费发票" },
	{ id: "10", text: "市内交通发票" },
	{ id: "11", text: "出租车发票" },
	{ id: "12", text: "长途车票" },
	{ id: "13", text: "航空服务发票" },
	{ id: "14", text: "通行费电子发票" },
	{ text: "自定义发票", id: "8" },
	{ id: "15", text: "税控盘" }
];

export const ProviderArr: string[] = [
	"办公用品类发票",
	"食品类发票（除烟、酒外）",
	"日用品类发票",
	"餐饮服务类发票",
	"燃料、动力类发票",
	"住宿服务类发票",
	"水电服务类发票",
	"收入类发票",
	"自定义发票",
	"停车费发票",
	"市内交通发票",
	"出租车发票",
	"长途车票",
	"航空服务发票",
	"高速公路发票",
	"税控盘"
];
